import { render } from "./RegionDashboardsMainFilterBlock.vue?vue&type=template&id=c8cc3480&scoped=true&ts=true"
import script from "./RegionDashboardsMainFilterBlock.vue?vue&type=script&lang=ts"
export * from "./RegionDashboardsMainFilterBlock.vue?vue&type=script&lang=ts"

import "./RegionDashboardsMainFilterBlock.vue?vue&type=style&index=0&id=c8cc3480&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8cc3480"]])

export default __exports__